import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\FetchCeremoniesDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchCeremoniesDossierByIdController.php
* @route '/api/dossier-ceremonies/{dossier}'
*/
const FetchCeremoniesDossierByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchCeremoniesDossierByIdController.url(args, options),
    method: 'get',
})

FetchCeremoniesDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier-ceremonies/{dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\FetchCeremoniesDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchCeremoniesDossierByIdController.php
* @route '/api/dossier-ceremonies/{dossier}'
*/
FetchCeremoniesDossierByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchCeremoniesDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\FetchCeremoniesDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchCeremoniesDossierByIdController.php
* @route '/api/dossier-ceremonies/{dossier}'
*/
FetchCeremoniesDossierByIdController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchCeremoniesDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\FetchCeremoniesDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchCeremoniesDossierByIdController.php
* @route '/api/dossier-ceremonies/{dossier}'
*/
FetchCeremoniesDossierByIdController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchCeremoniesDossierByIdController.url(args, options),
    method: 'head',
})

export default FetchCeremoniesDossierByIdController